import { toConditionBinding } from '@retail/calculus/types';
import {
  UploadedCustomerMarkup,
  CustomerMarkupConditionsPost,
} from '@retail/customer-markup/types';
import dayjs from 'dayjs';

interface Props {
  customerMarkups: UploadedCustomerMarkup[];
  supplierNumber: number;
}

export const getImportedCustomerMarkupConditions = ({ customerMarkups, supplierNumber }: Props) => {
  const customerMarkupConditions: CustomerMarkupConditionsPost[] = customerMarkups.map(
    ({ groupNumber, groupCode, mgItemNumber, gtinCode, validFrom, customerFactor }) => {
      const updatedValidFrom = validFrom
        ? dayjs(validFrom)?.format('YYYY-MM-DD')
        : dayjs(new Date()).format('YYYY-MM-DD');

      const binding = toConditionBinding({
        groupCode,
        groupNumber,
        mgItemNumber,
        supplierNumber,
      });

      return { customerMarkup: { factor: customerFactor }, binding, validFrom: updatedValidFrom };
    }
  );

  return customerMarkupConditions;
};
